const VARIANT_STYLES = {
  teal: {
    selected: 'bg-teal-600 border-teal-600 text-white shadow-md',
    unselected: 'bg-white border-gray-300 text-gray-700 hover:border-teal-400 hover:bg-teal-50',
  },
  primary: {
    selected: 'bg-primary-600 border-primary-600 text-white shadow-md',
    unselected: 'bg-white border-gray-300 text-gray-700 hover:border-primary-400 hover:bg-primary-50',
  },
}

const WellnessScoreQuestion = ({ score, value, onChange, error, variant = 'primary' }) => {
  const styles = VARIANT_STYLES[variant] ?? VARIANT_STYLES.primary
  const { key, label, emoji, prompt, anchors } = score

  return (
    <div>
      <label className="block text-base font-semibold text-gray-900 mb-1">
        {emoji} {label}
      </label>
      <p className="text-sm text-gray-600 mb-3">{prompt}</p>


      <div className="grid grid-cols-5 sm:grid-cols-10 gap-1.5">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => (
          <label
            key={rating}
            className={`relative flex items-center justify-center cursor-pointer touch-manipulation aspect-square rounded-lg border-2 transition-all min-h-[44px] ${
              value === rating ? styles.selected : styles.unselected
            }`}
          >
            <input
              type="radio"
              name={key}
              value={rating}
              checked={value === rating}
              onChange={() => onChange(rating)}
              className="sr-only"
              aria-label={String(rating)}
            />
            <span className="text-sm font-medium">{rating}</span>
          </label>
        ))}
      </div>
      <div className="flex mt-1.5 px-1">
        {anchors.map(({ label: anchorLabel, description }, i) => (
          <span
            key={anchorLabel}
            className={`flex-1 text-xs text-gray-400 ${i === 0 ? 'text-left' : i === anchors.length - 1 ? 'text-right' : 'text-center'}`}
          >
            {description}
          </span>
        ))}
      </div>

      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  )
}

export default WellnessScoreQuestion
